// Catalogue des prestations pour l'espace admin (aligné sur la grille Tarifs 2026, prix HT)
export const CATALOG = [
    { id: "recherche", label: "Recherche / diagnostic punaises de lit", price: 59, detail: "Déduite si traitement réalisé le jour même" },
    { id: "recherche-hotel", label: "Recherche / diagnostic (chambre d'hôtel)", price: 49, detail: "Déduite si traitement réalisé le jour même" },
    { id: "chimique-30", label: "Traitement chimique punaises (0 à 30 m²)", price: 180 },
    { id: "chimique-60", label: "Traitement chimique punaises (31 à 60 m²)", price: 190 },
    { id: "chimique-90", label: "Traitement chimique punaises (61 à 90 m²)", price: 210 },
    { id: "chimique-120", label: "Traitement chimique punaises (91 à 120 m²)", price: 230 },
    { id: "vapeur-30", label: "Traitement vapeur sèche 180°C (0 à 30 m²)", price: 350 },
    { id: "vapeur-60", label: "Traitement vapeur sèche 180°C (31 à 60 m²)", price: 400 },
    { id: "vapeur-90", label: "Traitement vapeur sèche 180°C (61 à 90 m²)", price: 450 },
    { id: "vapeur-120", label: "Traitement vapeur sèche 180°C (91 à 120 m²)", price: 500 },
    { id: "vapeur-canape", label: "Vapeur sèche : 1 canapé", price: 90 },
    { id: "vapeur-lit", label: "Vapeur sèche : 1 lit", price: 100 },
    { id: "fumigene", label: "Traitement par fumigène", price: 160 },
    { id: "gel-cafards", label: "Traitement gel anti-cafards (cuisine, salle d'eau, WC)", price: 59 },
    { id: "chimique-cafards-30", label: "Traitement chimique cafards (0 à 30 m²)", price: 170 },
    { id: "chimique-cafards-60", label: "Traitement chimique cafards (31 à 60 m²)", price: 190 },
    { id: "hotel", label: "Chambre d'hôtel : traitement vapeur (relouable le jour même)", price: 190 },
    { id: "custom", label: "Prestation personnalisée", price: 0 },
];

const easterSunday = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
};

const addDays = (date, n) => {
    const x = new Date(date);
    x.setUTCDate(x.getUTCDate() + n);
    return x.toISOString().slice(0, 10);
};

// Samedi, dimanche ou jour férié français -> majoration de 20 %
export const isMajorationDay = (isoDate) => {
    if (!isoDate) return false;
    const d = new Date(`${isoDate}T12:00:00`);
    if (Number.isNaN(d.getTime())) return false;
    if (d.getDay() === 0 || d.getDay() === 6) return true;
    const y = d.getFullYear();
    const fixed = [`${y}-01-01`, `${y}-05-01`, `${y}-05-08`, `${y}-07-14`, `${y}-08-15`, `${y}-11-01`, `${y}-11-11`, `${y}-12-25`];
    const easter = easterSunday(y);
    const movable = [addDays(easter, 1), addDays(easter, 39), addDays(easter, 50)];
    return fixed.includes(isoDate) || movable.includes(isoDate);
};

export const fmtPrice = (n) => `${Number(n).toFixed(2).replace(".", ",")} €`;

export const STATUS = {
    brouillon: { label: "À signer", classes: "bg-amber-100 text-amber-800" },
    signe: { label: "Signé", classes: "bg-blue-100 text-blue-800" },
    facture: { label: "Facturé", classes: "bg-green-100 text-green-800" },
};
